export const PrivacyPolicy = () => { 
    return (
            <div className='main about'>

                <div className='aside'><div></div></div>

                <div className='content has-aside static'>
                        <a href="https://flintt.me/"><div className='nav-logo'></div></a>

            
<h1>PRIVACY AND COOKIES POLICY</h1>

<p>Version number: 1</p>
<p>Effective date: 17.07.2025</p>

<h2>Who are we?</h2>
<p>We are Brather Ltd trading as “Flintt.me”. For privacy queries, you can contact us at info@flintt.me. </p>

<h2>What’s the purpose of this policy? </h2>
<p>It tells you what to expect when we collect personal information from users of our website/app. Please only use them if you are completely happy with this policy. </p>

<p>Generally, the policy covers only information provided to us. If you give personal information to other people, such as payment providers or other websites, please check their privacy policies. </p>

<h2>Might the policy change?</h2>
<p>Yes. We will give you notice of the new version by posting it on our service and communicating it otherwise if appropriate.</p>
 
<h2>What do we collect? </h2>
<p>Information that you upload to our service or otherwise give us such as:</p>
<ul>
    <li>your name and contact details;</li>
    <li>other information you provide on registration or otherwise;</li>
    <li>information about your authorised users;</li>
    <li>account information such as your username and password and your contact or other account preferences;</li>
    <li>details about your transactions on our service;</li>
    <li>information that you include in your profile (such as pronouns, sexual orientation and interests) or that you otherwise provide for display on our service or include in messages sent to other users via our service and/or in communications with us including surveys and feedback; and</li>
    <li>contact or other information which you give or allow us to use for newsletters or other marketing.</li>
</ul>

<p>Some of this information will be “special category data”, such as details relating to your sex life.</p>

<p>Automated browsing information about your use of our service such as: the internet protocol (IP) address used to connect your device to the internet, connection information such as browser type and version, information about your device including device-type and device identifier, operating system and platform, mobile network data, a unique reference number linked to the data you enter on our system, the site from which you arrived at our service, details of your activity with date/time stamps including pages you visited and your searches/transactions.  </p>

<p>Information about your location in order to show users your approximate distance from them. You will be asked to consent to this. You can withdraw your consent at any time as explained in our service or by ending your contract with us as explained in our terms and conditions. Please see below for an explanation of the way location information is shown to other users. </p>

<p>We may receive limited information about you from our payment/authentication providers (for verification purposes) or from other companies if you log in via social media/other websites. This information may include your name and email address. </p>

<h2>What’s our reason/legal basis for collecting the information?</h2>
<p>Because it’s necessary to take steps at your request to enter into a contract with you and/or to perform such a contract. This applies to information such as initial enquiries and to account, contact, transaction and profile information. </p>

<p>Because it’s in our “legitimate interests”, e.g., sending you marketing communications about our similar products/services, managing and improving our service including tracking usage patterns and preventing or detecting fraud or abuse. This applies to information such as contact details, automated browsing data and to surveys and feedback.</p>

<p>Because you’ve specifically agreed on our service (e.g., by selecting a consent box). This applies to “special category data” (explained above) and it may apply to contact or other information that you specifically agree to us using for certain kinds of marketing. You can withdraw permission at any time as explained on our service or by emailing us at the above email address.  </p>

<p>Because it’s necessary to comply with legal or regulatory obligations.</p>

<h2>How long do we keep personal information? </h2>
<p>We will generally hold your information for our default standard retention period of six years after the end of our contract with you, but we may delete it earlier/later as set out below or in our terms and conditions.</p>

<p>We will keep your information that we use for email newsletters or other marketing until you tell us to stop sending you such messages.</p>

<p>We will generally keep automated browsing information for up to 14 months.     </p>

<h2>To whom do we send or make available your personal information? </h2>
<p>To other people who supply us with services, e.g., website/app hosting and management, app admin, payment, messaging, email distribution, e-commerce, online advertising, analytics etc. </p>

<p>To other users of our service if you: </p>
<ul>
    <li>include your real name in your username (which we strongly advise you against doing);</li>
    <li>include your personal information in a public action on our service, e.g., in a username or profile (and your online status may also be shown to other users);</li>
    <li>include your personal information in communications to other users; or</li>
    <li>consent to use of your location to display your approximate distance from other users (not on a map).</li>
</ul>

<p>To regulators, the police and other law enforcement or official authorities to help deal with fraud and abuse and/or comply with legal requirements and/or to protect us or others.</p>

<p>To insurers and professional advisers in connection with our insurance cover or to deal with legal claims.</p>

<p>To (actual or potential) buyers so far as reasonably necessary in the case of a proposed or completed sale or merger or business combination involving all or the relevant part of our business.</p>

<h2>Do we send your information outside the UK?</h2>
<p>Your personal information (e.g., name, username, contact details, IP address, browsing information) is transferred to companies outside the UK (generally to the US) that provide us with the services mentioned above (see: To whom do we send or make available your personal information?). Where this happens, we will ensure that there is a legal basis to do so, for example in accordance with “adequacy regulations” applying to particular countries, (e.g., the “UK-US Data Bridge” if applicable) or under contracts with standard contractual clauses sanctioned by the Information Commissioner that are designed to provide adequate safeguards for your personal information. </p>

<h2>What rights do you have? </h2>
<p>If the legal requirements are met: To ask us for access to your personal information, to rectify it if there are mistakes, to delete it or restrict its use in certain circumstances or to “data portability” or to withdraw any consent you’ve given (e.g., marketing).</p>

<p>You may also have the right to object to use of your personal information in certain circumstances.</p>

<p>If you have a complaint about how we are dealing with your personal information, please contact us via the email address above. If you are not happy with our response or think we are not handling your personal information in accordance with the law, you have the right to complain to the Information Commissioner’s Office (ICO).</p>

<p>For more information about your rights, visit the ICO’s website: <a href="https://www.ico.org.uk">www.ico.org.uk</a>.</p>

<h2>What about cookies?</h2>
<p>We and/or other companies use cookies and other tracking technologies on our website. A cookie is an identifier (a small file of letters and numbers) that is sent to your web browser.  Cookies are widely used to make websites work, or work more efficiently, as well as to provide information to the website owner or others. Some are temporary “session” cookies that remain in the cookie file of your browser only until your browser is closed. Whereas persistent cookies stay for longer (depending on the lifetime of the specific cookie). Our site’s functionality will be limited if you configure your browser to reject cookies.</p>

<p>We ourselves may place the following types of cookies:</p>

<strong>
    <p>Type of cookie</p>
</strong>
<p>Purpose</p>
<strong>
    <p>Logged-in status</p>
</strong>
<p>Assess whether you are logged in to our site</p>
<strong>
    <p>“Remember me”</p>
</strong>
<p>Remember you and speed up your login when you return to our site</p>
<strong>
    <p>Authentication</p>
</strong>
<p>Identify and authenticate you to help you move easily through the site </p>
<strong>
    <p>Preferences</p>
</strong>
<p>Store information about the preferences you’ve selected (e.g., favourites, currency, wish-lists) and personalise the site</p>
<strong>
    <p>Security</p>
</strong>
<p>Provide security-related features to protect our site, for example to help stop fraudulent logins</p>
<strong>
    <p>Cookie notice</p>
</strong>
<p>Store your response to our cookie notice</p>


<p>Companies which provide us with a service also place cookies. Some of these cookies (e.g., from Google) may involve certain information, such as your name and contact details and/or the IP and web address of the page you’re visiting, being sent to the company concerned. Below is a summary of the kinds of cookies used together with details about who places them and where you can go to get more information and to opt out (where possible):</p>

<p>Analytics cookies: These kinds of cookies recognise and count the number of website visitors as well as providing other information about the visit such as duration, route through the website and where the visitor came from. This information helps us to improve the way our website works, for example by making sure users find what they need easily. These cookies are provided by:</p>

<p>Google Analytics (“GA”). More information:</p>
<ul>
    <li>Google’s <a href="https://support.google.com/analytics/answer/6004245">overview of GA data practices and safeguarding</a></li>
    <li>how to <a href="https://tools.google.com/dlpage/gaoptout/">specifically opt out from GA cookies</a></li>
    <li>Google’s <a href="https://policies.google.com/technologies/partner-sites">use of its partners’ data</a></li> 
</ul>

<p>Advertising cookies: These kinds of cookies are typically used to personalise ads on this or other sites based on your use of our site, to measure ad effectiveness (for example, how often you click on or view ads and whether you go on to buy something from the advertiser) and to stop you being shown the same ad repeatedly. These cookies are provided by:</p>

<p>Google (including Analytics Ad Features / AdSense / Doubleclick)</p>
<p>how Google <a href="https://policies.google.com/technologies/ads">uses cookies and other technologies in advertising</a> including how to opt out of advertising cookies (this explains how ad personalisation works)</p>
<p>Google’s <a href="https://policies.google.com/technologies/partner-sites">use of its partners’ data</a> </p>

<p>Facebook (including “Facebook Pixel”)</p>
<p>Facebook’s <a href="https://www.facebook.com/policies/cookies/">cookies policy</a> (see especially under “Advertising, recommendations, insights and measurement”) including how to control Facebook’s use of cookies</p>
<p>Facebook’s <a href="https://www.facebook.com/policy.php">privacy policy</a></p>

<p>Note that there are various places where you can go to opt out of many companies’ advertising cookies in one go including some or all of the above:</p>
<ul>
    <li><a href="https://www.networkadvertising.org/choices">www.networkadvertising.org/choices</a></li>
    <li><a href="https://www.youronlinechoices.com/">http://www.youronlinechoices.com/</a></li>
    <li><a href="https://optout.aboutads.info">http://optout.aboutads.info </a></li>
</ul>

<p>Payment provider cookies: Our payment provider may place cookies if you use their payment services on our service: </p>
<p>Paypal’s <a href="https://www.paypal.com/uk/webapps/mpp/ua/privacy-full">privacy policy</a> </p>
<p>Stripe’s <a href="https://stripe.com/gb/privacy">privacy policy</a></p>

<p>Email provider cookies: Our email services provider may place cookies in connection with its service:</p>
<p>Mailchimp’s <a href="https://mailchimp.com/en-gb/legal/cookies/">cookies policy</a></p>

<p>Third party log-in cookies: If you log in through a third party website, that website will place its own cookies on your computer:</p>
<p>Facebook’s <a href="https://www.facebook.com/policy.php">privacy policy</a></p>
<p>Google’s <a href="https://policies.google.com/privacy?hl=en-UK">privacy policy</a></p>



                </div> 
            </div>
    )
}